import {
    DataSourceColumnOldDataLoaderFactory,
    DatasourceColumnOldDataLoaderFactoryOptions,
} from 'src/app/dashboards/common/data-loaders/datasource-column-old';
import {
    EngagementSessionsByDateDataLoaderFactory,
    EngagementSessionsByDateDataLoaderFactoryOptions,
} from '../../lastarchon-engagement/data-loaders/engagement-sessions-by-date';
import {
    EngagementSessionsByDayNoDataLoaderFactory,
    EngagementSessionsByDayNoDataLoaderFactoryOptions,
} from '../../lastarchon-engagement/data-loaders/engagement-sessions-by-day-no';
import {
    EngagementSessionsDistributionByDaysDataLoaderFactory,
    EngagementSessionsDistributionByDaysDataLoaderFactoryOptions,
} from '../../lastarchon-engagement/data-loaders/engagement-sessions-distribution-by-days';
import {
    EngagementSessionsDistributionBySessionsDataLoaderFactory,
    EngagementSessionsDistributionBySessionsDataLoaderFactoryOptions,
} from '../../lastarchon-engagement/data-loaders/engagement-sessions-distribution-by-sessions';
import {
    UsersdashActivityDailyDataLoaderFactory,
    UsersdashActivityDailyDataLoaderFactoryOptions,
} from '../../lastarchon-users/data-loaders/usersdash-activity-daily';
import {
    UsersdashActivityMonthlyDataLoaderFactory,
    UsersdashActivityMonthlyDataLoaderFactoryOptions,
} from '../../lastarchon-users/data-loaders/usersdash-activity-monthly';
import {
    RetentionByDayNoDataLoaderFactory,
    RetentionByDayNoDataLoaderFactoryOptions,
} from '../retention/data-loaders/retention-by-day-no';
import {
    RetentionByFirstOpenDateDataLoaderFactory,
    RetentionByFirstOpenDateDataLoaderFactoryOptions,
} from '../retention/data-loaders/retention-by-first-open-date';
import {
    SalesAnalyticsVsStoreDataLoaderFactory,
    SalesAnalyticsVsStoreDataLoaderFactoryOptions,
} from '../sales/data-loaders/sales-analytics-vs-store';
import {
    SalesFilterAppVersionDataLoaderFactory,
    SalesFilterAppVersionDataLoaderFactoryOptions,
} from '../sales/data-loaders/sales-filter-app-version';
import {
    DataSourceColumnDataLoaderFactory,
    DatasourceColumnDataLoaderFactoryOptions,
} from './datasource-column';
import {
    FakeDatetimeDataDataLoaderFactory,
    FakeDatetimeDataDataLoaderFactoryOptions,
} from './fake-data';
import {
    ModifyTimeDataLoaderFactory,
    ModifyTimeDataLoaderFactoryOptions,
} from './modify-time';
import {
    SegmentDataSourceColumnDataLoaderFactory,
    SegmentDatasourceColumnDataLoaderFactoryOptions,
} from './segments';

/**
 * Contains DataLoaderFactoryIds which
 * are project independent and can be used in more than one dashboard
 */
export const CommonDataLoaderFactoryIds = [
    'common.sales.sales_datetime',
    'common.sales.sales_cumulative_by_day_no',
    'common.sales.sales_arpu_proportional',
    'common.sales.sales_analytics_vs_store',

    'common.retention.retention_by_day_no',
    'common.retention.retention_by_first_open_date',

    'common.engagement.engagement_sessions_by_day_no',

    'common.filter.datasource_column',
] as const;

export type CommonDataLoaderFactoryId =
    (typeof CommonDataLoaderFactoryIds)[number];

export const commonDataLoaderFactories = {
    // Sales
    'common.sales.sales_analytics_vs_store': (
        options: SalesAnalyticsVsStoreDataLoaderFactoryOptions
    ) => new SalesAnalyticsVsStoreDataLoaderFactory(options),
    'common.sales.filter.app_version': (
        options: SalesFilterAppVersionDataLoaderFactoryOptions
    ) => new SalesFilterAppVersionDataLoaderFactory(options),

    // Retention
    'common.retention.retention_by_day_no': (
        options: RetentionByDayNoDataLoaderFactoryOptions
    ) => new RetentionByDayNoDataLoaderFactory(options),
    'common.retention.retention_by_first_open_date': (
        options: RetentionByFirstOpenDateDataLoaderFactoryOptions
    ) => new RetentionByFirstOpenDateDataLoaderFactory(options),

    // Engagement
    'common.engagement.sessions_by_day_no': (
        options: EngagementSessionsByDayNoDataLoaderFactoryOptions
    ) => new EngagementSessionsByDayNoDataLoaderFactory(options),
    'common.engagement.sessions_by_date': (
        options: EngagementSessionsByDateDataLoaderFactoryOptions
    ) => new EngagementSessionsByDateDataLoaderFactory(options),
    'common.engagement.sessions_distribution_by_days': (
        options: EngagementSessionsDistributionByDaysDataLoaderFactoryOptions
    ) => new EngagementSessionsDistributionByDaysDataLoaderFactory(options),
    'common.engagement.sessions_distribution_by_sessions': (
        options: EngagementSessionsDistributionBySessionsDataLoaderFactoryOptions
    ) => new EngagementSessionsDistributionBySessionsDataLoaderFactory(options),

    // Users
    'common.users.usersdash_activity_daily': (
        options: UsersdashActivityDailyDataLoaderFactoryOptions
    ) => new UsersdashActivityDailyDataLoaderFactory(options),
    'common.users.usersdash_activity_monthly': (
        options: UsersdashActivityMonthlyDataLoaderFactoryOptions
    ) => new UsersdashActivityMonthlyDataLoaderFactory(options),

    ////////////////
    // Filters
    'common.filter.datasource_column_old': (
        options: DatasourceColumnOldDataLoaderFactoryOptions
    ) => new DataSourceColumnOldDataLoaderFactory(options),
    'common.filter.datasource_column': (
        options: DatasourceColumnDataLoaderFactoryOptions
    ) => new DataSourceColumnDataLoaderFactory(options),
    'common.filter.segment': (
        options: SegmentDatasourceColumnDataLoaderFactoryOptions
    ) => new SegmentDataSourceColumnDataLoaderFactory(options),

    ////////////////
    // Last Extract
    'common.modify_time': (options: ModifyTimeDataLoaderFactoryOptions) =>
        new ModifyTimeDataLoaderFactory(options),

    ////////////////
    // Fake data
    'common.fake_datetime_data': (
        options: FakeDatetimeDataDataLoaderFactoryOptions
    ) => new FakeDatetimeDataDataLoaderFactory(options),
};
